var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3503_25456)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3503_25456)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00531006 19.7938C0.00531006 30.7404 8.94233 39.5876 19.9243 39.5876C23.2946 39.5876 26.5513 38.8004 29.4672 37.2259L38.4042 39.9625C39.1237 40.1874 39.7675 39.5127 39.5781 38.8004L36.8137 30.5155C38.8965 27.3664 39.9947 23.6176 39.9947 19.7938C39.9947 8.84724 31.0577 0 20 0C8.94233 0 0.00531006 8.92221 0.00531006 19.7938Z",
    fill: "url(#paint0_linear_3503_25456)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89872 19.7942C1.82298 29.7286 9.96476 37.7886 20 37.7886C23.1431 37.7886 26.2483 37.0013 29.0127 35.4268C29.24 35.2768 29.5429 35.2768 29.7322 35.3518L37.306 37.6386L34.996 30.6658C34.9203 30.3659 34.9203 30.1035 35.1475 29.8785C37.1545 26.917 38.2527 23.3931 38.2527 19.7942C38.2527 9.85979 30.1109 1.7998 20.0757 1.7998C10.0405 1.7998 1.89872 9.85979 1.89872 19.7942Z",
    fill: "url(#paint1_linear_3503_25456)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2061 25.8674C14.2061 23.6556 15.9102 22.7933 19.432 21.6312C20.5302 21.2563 21.4769 21.0689 21.8935 21.0689C22.2343 21.0689 22.4994 21.1438 22.4994 21.7811L22.3479 25.1926C22.3479 26.3922 22.31 27.1795 21.5527 27.8542C20.9468 28.4166 19.1291 29.2788 17.9551 29.2788C14.9635 29.2788 14.2061 26.8421 14.2061 25.8674ZM14.5469 21.7062C10.7601 22.9808 9.66187 24.2929 9.66187 26.5796C9.66187 28.1916 10.3814 29.5787 11.5174 30.5534C12.4642 31.4156 13.9032 31.903 15.6451 31.903C17.2735 31.903 18.5989 31.1157 19.9243 30.4409C21.0604 29.8036 21.8177 29.2788 22.2343 29.2788C22.613 29.2788 22.9159 29.7287 23.1431 30.1035C24.2035 31.3407 25.6046 31.903 27.0436 31.903C29.9216 31.903 31.9666 29.6162 31.9666 29.3538C31.9666 28.9789 31.8151 28.604 31.5879 28.604C31.4364 28.604 31.0956 28.8664 30.8305 29.0164C30.4897 29.1663 29.9216 29.3538 29.3536 29.3538C27.0436 29.3538 26.4377 27.0295 26.5892 24.3678L26.9679 14.396C27.1572 10.1598 25.0744 7.68555 20.7953 7.68555C16.5161 7.68555 9.77547 11.8093 9.77547 14.7708C9.77547 15.2957 10.0784 15.5581 10.6086 15.5581C11.5174 15.5581 13.0701 15.1832 13.941 14.4709C14.4333 14.1335 14.5091 13.4587 14.5469 12.5215C14.6984 10.7596 16.7433 9.97233 18.3717 9.97233C22.0449 9.97233 22.7645 12.8214 22.6887 14.9583L22.613 17.545C22.613 18.4822 22.4994 18.932 21.6284 19.2319L14.5469 21.7062Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3503_25456",
    x1: 39.357,
    y1: 19.9124,
    x2: 2.69527,
    y2: 19.9124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129412,
    stopColor: "#7A2563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678431,
    stopColor: "#8C287B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C287B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3503_25456",
    x1: 1.96817,
    y1: 19.7979,
    x2: 38.2573,
    y2: 19.7979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168627,
    stopColor: "#742356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678431,
    stopColor: "#762562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972983"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3503_25456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3503_25456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2b0a3e3c2c5df26f327563f7ac98e854.svg";
export { ForwardRef as ReactComponent };